import { NgModule } from '@angular/core';
import { AuthCallbackComponent } from '@app/auth/auth-callback.component';
import { RouterModule, Routes } from '@angular/router';
import { LoggedOutComponent } from '@app/auth/logged-out.component';
import { UseSiriusComponent } from '@app/auth/use-sirius.component';

const routes: Routes = [
  {
    path: 'callback',
    component: AuthCallbackComponent,
  },
];

@NgModule({
  declarations: [AuthCallbackComponent, LoggedOutComponent, UseSiriusComponent],
  imports: [RouterModule.forChild(routes)],
})
export class AuthModule {}
